import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const outwardingAnalyticsServices = {
	gateway,
	fetchOutwardingImagesById,
};

function gateway({ req, method }) {
	switch (method) {
		case 'FIND_OUTWARDING_IMAGES':
			return findOutwardingImages(req);
		// case 'FETCH_PRODUCT_IMAGES_BY_ID':
		// return findProductImagesById(req);
		default:
			break;
	}
	return new Promise();
}

function findOutwardingImages(req) {
	const { params = {} } = req;

	const url = toQueryStringURL(endpoints.FIND_OUTWARDING_IMAGES, params);

	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
	// return mockFetch1(url, requestOptions);
}

function fetchOutwardingImagesById(req) {
	const { params = {} } = req;

	const url = toQueryStringURL(endpoints.FIND_OUTWARDING_IMAGES_BY_ID, params);

	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
	// return mockFetch2(url, requestOptions).then(handleResponse);
}

// function skuStock() {
// const requestOptions = {
// method: 'GET',
// headers: {
// ...authHeader(),
// 'Content-Type': 'application/json',
// },
// };
// return fetch(endpoints.SKU_STOCK, requestOptions).then(handleResponse);
// }

export default outwardingAnalyticsServices;
